<template>
  <section id="ReportBug" class="jcs-portal-card">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <form @submit.prevent="sendReport">
            <div class="col-12">
              <h1>Report Bug</h1>
            </div>
            <div class="col-12 mb-4" v-if="success">
              <div class="ui visible success message">
                <i class="close icon" @click="success = false"></i>
                <div class="header">Bug Submitted.</div>
                <p>Bug submitted successfully.</p>
              </div>
            </div>

            <div class="col-12 mb-4">
              <div class="form-row">
                <div class="col-md-12">
                  <label for="Description"
                    >Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    maxlength="1000"
                    rows="15"
                    type="text"
                    name="Description"
                    v-model="description"
                    placeholder="Description"
                  />
                  <div
                    v-if="isFormIncomplete && !description"
                    class="text-danger"
                  >
                    Please fill this field
                  </div>
                </div>
                <div class="col-md-12 mt-4">
                  <label>Bug Screenshot </label>
                  <input
                    type="file"
                    id="file"
                    ref="file"
                    @change="onFileChange"
                  />
                  <div v-if="fileUploadError" class="text-danger mt-2">
                    {{ fileUploadError }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-3">
              <button type="submit" class="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "ReportBug",
  mounted() {},
  data() {
    return {
      description: "",
      fileName: "",
      fileData: null,
      isFormIncomplete: false,
      fileUploadError: "",
      success: false,
    };
  },
  methods: {
    sendReport() {
      if (!this.description) {
        this.isFormIncomplete = true;
      } else {
        this.isFormIncomplete = false;
        const fd = new FormData();
        fd.append("Description", this.description);
        fd.append("BugFiles", this.$refs.file.files[0]);
        apiService
          .submitBug(fd)
          .then(() => {
            this.success = true;
            this.description = "";
            this.$refs.file.value = null;
          })
          .catch((err) => {
            this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
              title: err.error.response.data.title,
              autoHideDelay: 10000,
              appendToast: false,
              variant: "danger",
              solid: true,
            });
          });
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      let fileTypes = ["jpg", "jpeg", "png"];
      let extension = files[0].name
        .split(".")
        .pop()
        .toLowerCase();
      let isSuccess = fileTypes.indexOf(extension) > -1;
      if (!isSuccess) {
        this.$refs.file.value = null;
        this.fileUploadError = "Only JPEG, JPG and PNG files are supported.";
        return;
      }
      if (files[0]?.size > 1024 * 1024) {
        this.$refs.file.value = null;
        this.fileUploadError = "Maximum file size of 1MB allowed.";
        return;
      }
      this.createImage(files[0]);
    },
    createImage(file) {
      //acceptable file types
      var reader = new FileReader();
      var vm = this;
      this.fileName = file.name;

      reader.onload = (e) => {
        vm.fileData = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
